import { createContext } from "react";

const CambioPuestoContext = createContext();

export default CambioPuestoContext;
